import styled from '../../styles/theme';
import { rem } from 'polished';
import { TrimCarouselTemplate } from './TrimCarouselTemplate';
import media from '../../styles/media';
import { breakpoints } from '../../styles/AC/theme';

export const TrimCarouselStyled = styled(TrimCarouselTemplate)`
    position: relative;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;

    .image-item {
        padding: 10px;
        box-sizing: border-box;
    }

    .trimCarousel {
        padding: ${rem('30px')} 0 ${rem('10px')} 0;
        overflow: initial;

        @media (min-width: ${breakpoints.md}px) and (max-width: 1200px) {
            width: 90%;
        }

        & > ul {
            margin: 0 auto;
        }

        ${media.sm`
            padding: 30px 0 10px 0;
        `}
        .react-multi-carousel-track {
            z-index: 1;
        }

        ${media.lg`
            padding: 0;
            max-width: 1000px;
            margin: 0 auto;
        `}
    }

    .trimItemWrap {
        position: relative;
        background-color: white;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        max-width: ${rem('550px')};
        margin: 0 auto;
        height: 100%;

        &.benefits {
            &.monthlyPrices .priceBox > div:first-child {
                min-height: ${rem('230px')};
            }

            .trimContainer {
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
            }

            .generalInfoContainer {
                max-height: ${rem('380px')};
            }
        }

        & > div {
            width: 95%;
            margin: 0 auto;
        }
    }

    .currentSlideSection {
        display: none;
        font-size: ${rem('13px')};
        text-align: center;

        @media (max-width: ${breakpoints.md}px) {
            display: block;
        }
    }

    .carouselArrows-wrapper {
        position: absolute;
        text-align: right;
        display: flex;
        justify-content: space-between;
        width: 100%;
        left: 0;
        top: 0;
        height: 100%;
        align-items: center;

        &__btnsSection {
            display: flex;
            flex-grow: 1;
            justify-content: space-between;
            max-width: 100%;
            margin: auto;
            height: 98%;

            .arrow-icon-holder {
                display: flex;
                z-index: 99999;
                width: ${rem('80px')};
                justify-content: center;
                align-items: center;

                @media (max-width: ${breakpoints.xs}px) {
                    width: ${rem('33px')};
                }
            }

            .arrow-icon-holder-left {
                background-image: linear-gradient(to left, rgb(255 255 255 / 0%) 0%, rgb(255 255 255) 70%);

                @media (max-width: ${breakpoints.xs}px) {
                    background-image: unset;
                }
            }

            .arrow-icon-holder-left-hide {
                background-image: unset !important;
            }

            .arrow-icon-holder-right {
                background-image: linear-gradient(to right, rgb(255 255 255 / 0%) 0%, rgb(255 255 255) 70%);

                @media (max-width: ${breakpoints.xs}px) {
                    background-image: unset;
                }
            }

            .arrow-icon-holder-right-hide {
                background-image: unset !important;
            }

            .arrowBtn {
                background-color: ${({ theme }) => theme.colors.blue};
                height: ${rem('32px')};
                width: ${rem('32px')};
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 5;
                ${media.sm`
                    height: 40px;
                    width: 40px;
                `}

                .vertical {
                    h2 {
                        display: none;
                    }
                }

                .iconClass {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    height: auto !important;
                }

                svg {
                    width: ${rem('16px')};
                    height: ${rem('16px')};

                    ${media.sm`
                        height: 24px;
                        width: 24px;
                    `}
                }

                &--disabled {
                    pointer-events: none;
                    background-color: ${({ theme }) => theme.colors.grey4};
                }
                &--left {
                    svg {
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }

    .trimCarouselCenter {
        @media (min-width: ${breakpoints.md}px) {
            visibility: hidden;
        }
    }
`;
